import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import { ElementFullWidth } from "./style";
import { LEVELS_MAP_CONST_TO_STRING, LEVELS_MAP_NUMBER_TO_STRING } from "./consts";
var booleanFormatter = function booleanFormatter(value) {
  return value ? 'Yes' : 'No';
}; // eslint-disable-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var arrayExistenceBooleanFormatter = function arrayExistenceBooleanFormatter(value) {
  return value && value.length ? 'Yes' : 'No';
}; // eslint-disable-line @typescript-eslint/no-explicit-any
var existenceFormatter = function existenceFormatter(value) {
  return value != null ? value : 'N/A';
}; // eslint-disable-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var levelsFormatter = function levelsFormatter(value) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var number = Number(value);
  if (isNaN(number)) {
    return LEVELS_MAP_CONST_TO_STRING[value] ? LEVELS_MAP_CONST_TO_STRING[value] : value;
  }
  return LEVELS_MAP_NUMBER_TO_STRING[number] ? LEVELS_MAP_NUMBER_TO_STRING[number] : number;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var englishExamFormatter = function englishExamFormatter(value) {
  return typeof value === 'string' ? value.replace('_', ' ') : 'N/A';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var numberFormatter = function numberFormatter(value) {
  var number = Number(value);
  if (isNaN(number)) {
    return value;
  }
  return number;
};

// eslint-disable-next-line @typescript-eslint/ban-types
var validVisaFormatter = function validVisaFormatter(value) {
  var validities = [];
  if (value.validCanadianStudyPermitOrVisitorVisa) {
    validities.push('Canadian Study Permit or Visitor Visa');
  }
  if (value.validUSStudyVisaOrVisitorVisa) {
    validities.push('USA F1 Visa');
  }
  if (value.validAustraliaStudyVisaOrVisitorVisa) {
    validities.push('Australian Student Visa');
  }
  if (value.validUKStudyVisaOrVisitorVisa) {
    validities.push('UK Student Visa (Tier 4) or Short Term Study Visa');
  }
  if (value.validIrelandStudyVisaOrVisitorVisa) {
    validities.push('Irish Stamp 2');
  }
  if (validities.length) {
    return validities.join(', ');
  }
  return "I don't have this";
};
var sections = {
  'Address Detail': {
    'programApplication.applicant.addressDetail.address': {
      title: 'Address',
      Wrapper: ElementFullWidth
    },
    'programApplication.applicant.addressDetail.city': {
      title: 'City/Town'
    },
    'programApplication.applicant.addressDetail.provinceState': {
      title: 'Province/State'
    },
    'programApplication.applicant.addressDetail.country': {
      title: 'Country'
    },
    'programApplication.applicant.addressDetail.postalZipCode': {
      title: 'Postal/Zip Code'
    },
    'programApplication.applicant.addressDetail.phoneNumber': {
      title: 'Phone Number'
    },
    'programApplication.applicant.email': {
      title: 'E-Mail'
    }
  },
  'Personal Info': {
    'programApplication.applicant.personalInformation.firstName': {
      title: 'First Name'
    },
    'programApplication.applicant.personalInformation.middleName': {
      title: 'Middle Name'
    },
    'programApplication.applicant.personalInformation.lastName': {
      title: 'Last Name'
    },
    'programApplication.applicant.personalInformation.dateOfBirth': {
      title: 'Date of Birth'
    },
    'programApplication.applicant.personalInformation.firstLanguage': {
      title: 'First Language'
    },
    'programApplication.applicant.personalInformation.countryOfCitizenship': {
      title: 'Country of Citizenship'
    },
    'programApplication.applicant.personalInformation.passportNumber': {
      title: 'Passport Number'
    },
    'programApplication.applicant.personalInformation.gender': {
      title: 'Gender'
    },
    'programApplication.applicant.personalInformation.maritalStatus': {
      title: 'Marital Status'
    }
  },
  'Background Info': {
    'programApplication.applicant.backgroundInformation.refusedVisaForCanadaUSAOrAnyOtherCountry': {
      title: 'Have you been refused a visa from Canada, the USA, the United Kingdom, New Zealand, Australia or Ireland?',
      formatter: booleanFormatter
    },
    'programApplication.applicant.backgroundInformation': {
      title: 'Do you have a valid Study Permit / Visa?',
      formatter: validVisaFormatter
    },
    'programApplication.applicant.backgroundInformation.informationText': {
      title: 'If you answered "Yes" to any of the questions above, please provide more details below',
      // eslint-disable-line @typescript-eslint/no-explicit-any
      formatter: existenceFormatter
    }
  },
  'Education Summary': {
    'programApplication.applicant.educationSummary.countryOfEducation': {
      title: 'Country of Education'
    },
    'programApplication.applicant.educationSummary.highestLevelOfEducation': {
      title: 'Highest Level of Education',
      formatter: levelsFormatter
    },
    'programApplication.applicant.educationSummary.gradingScheme': {
      title: 'Grading Scheme'
    },
    'programApplication.applicant.educationSummary.gradeScale': {
      title: 'Grade Scale',
      formatter: numberFormatter
    },
    'programApplication.applicant.educationSummary.grade': {
      title: 'Grade',
      formatter: numberFormatter
    },
    'programApplication.applicant.educationSummary.convertedGrade': {
      title: 'Converted Grade',
      formatter: numberFormatter
    },
    'programApplication.applicant.educationSummary.graduatedFromMostRecentSchool': {
      title: 'Graduated from Most Recent School',
      formatter: booleanFormatter
    }
  },
  'Program Info': {
    'programApplication.program.name': {
      title: 'Program'
    },
    'programApplication.program.applicationFee': {
      title: 'Application Fee'
    },
    'programApplication.program.tuition': {
      title: 'Tuition'
    }
  },
  'Test Scores': {
    // currently AB supports only 0 or 1 English exam
    'programApplication.applicant.exams.englishExams.[0].type': {
      title: 'English Exam Type',
      formatter: englishExamFormatter
    },
    'programApplication.applicant.exams.englishExams.[0].examDate': {
      title: 'Exam Date',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.englishExams.[0].scores.listening': {
      title: 'Listening Score',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.englishExams.[0].scores.reading': {
      title: 'Reading Score',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.englishExams.[0].scores.writing': {
      title: 'Writing Score',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.englishExams.[0].scores.speaking': {
      title: 'Speaking Score',
      formatter: existenceFormatter
    }
  },
  GRE: {
    'programApplication.applicant.exams.gre': {
      title: 'I have GRE exam scores',
      formatter: arrayExistenceBooleanFormatter
    },
    'programApplication.applicant.exams.gre.[0].examDate': {
      title: 'Exam Date',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].scores.verbal': {
      title: 'Verbal',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].scores.quantitative': {
      title: 'Quantitative',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].scores.writing': {
      title: 'Writing',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].additionalInformation.percentile.verbal': {
      title: 'Verbal Rank',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].additionalInformation.percentile.quantitative': {
      title: 'Quantitative Rank',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gre.[0].additionalInformation.percentile.writing': {
      title: 'Writing Rank',
      formatter: existenceFormatter
    }
  },
  GMAT: {
    'programApplication.applicant.exams.gmat': {
      title: 'I have GMAT exam scores',
      formatter: arrayExistenceBooleanFormatter
    },
    'programApplication.applicant.exams.gmat.[0].examDate': {
      title: 'Exam Date',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].scores.verbal': {
      title: 'Verbal',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].scores.quantitative': {
      title: 'Quantitative',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].scores.writing': {
      title: 'Writing',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].scores.total': {
      title: 'Total',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].additionalInformation.percentile.verbal': {
      title: 'Verbal Rank',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].additionalInformation.percentile.quantitative': {
      title: 'Quantitative Rank',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].additionalInformation.percentile.writing': {
      title: 'Writing Rank',
      formatter: existenceFormatter
    },
    'programApplication.applicant.exams.gmat.[0].additionalInformation.percentile.total': {
      title: 'Total Rank',
      formatter: existenceFormatter
    }
  }
};
export default sections;